import React from 'react';
import classNames from 'classnames';
import * as Variant from './variant';
import type { AvatarProps } from './types';
import './avatar.scss';

const PLACEHOLDER_COMPONENTS = [
  <Variant.First key="1" />,
  <Variant.Second key="2" />,
  <Variant.Third key="3" />,
  <Variant.Fourth key="4" />,
  <Variant.Fifth key="5" />,
  <Variant.Sixth key="6" />,
  <Variant.Seventh key="7" />,
  <Variant.Eighth key="8" />,
];

function randomize<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}

const Placeholder: React.FC<{ blur?: boolean }> = ({ blur }) =>
  blur ? <Variant.Blur /> : randomize(PLACEHOLDER_COMPONENTS);

export const Avatar = React.memo<AvatarProps>(
  ({ className, onLoad, blur = false, src, variant = 'normal', bordered }) => (
    <div className={classNames('avatar-default', variant, className, { bordered })}>
      {!!src && (
        <img
          src={src}
          alt="avatar"
          onLoad={() => {
            if (onLoad) onLoad();
          }}
        />
      )}
      {!src && <Placeholder blur={blur} />}
    </div>
  )
);
